const formatCurrency = amount => {
  return Intl.NumberFormat('de-DE', {
    currency: 'EUR',
    minimumFractionDigits: 2,
    style: 'currency',
  }).format(amount);
};

export default formatCurrency;
